<template>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 23"
    aria-hidden="true"
  >
    <path
      d="M5 2.5A2.48 2.48 0 112.5 0 2.49 2.49 0 015 2.5zM5 7H0v16h5zm8 0H8v16h5v-8.4c0-4.67 6-5 6 0V23h5V12.87C24 5 15.08 5.28 13 9.16z"
    />
  </svg>
</template>
